import { useState, useEffect } from "react";
import useWindowSize from "hooks/useWindowSize.jsx";
import { MdMenuOpen } from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { FiMessageSquare } from "react-icons/fi";
import { AiOutlineLeft, AiOutlineUser } from "react-icons/ai";
import { ImFileText } from "react-icons/im";
import styles from "../profile/profile.module.css";
import { NavLink } from "react-router-dom";
export default function CustomerSidebar({ fullName }) {
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();
  useEffect(() => {
    if (width && width > 992 && isOpen === false) {
      setIsOpen(true);
    }
    if (width && width < 992 && isOpen === true) {
      setIsOpen(false);
    }
  }, [width]);

  return (
    <>
      {width && width < 992 && (
        <button
          style={{
            position: "fixed",
            zIndex: "10",
            top: "-15px",
            backgroundColor: "#ccc",
          }}
          className="btn btn-mobile-menu mt-4 "
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <MdMenuOpen></MdMenuOpen>
        </button>
      )}

      {isOpen && (
        <div
          className={` d-block ${width && width < 992 && "mobile-sidebar"} ${
            styles.sidebarr
          }`}
          style={{
            width: "250px",
            position: "sticky",
            top: "0",
            height: "auto",
            backgroundColor: "#203B8C",
            zIndex: "2",
          }}
        >
          <ul
            className={`menu1 nav nav-pills flex-column mb-sm-auto mb-0 align-items-center justify-content-around px-2 ${styles.ulProfile} `}
            id="menu"
          >
            <AiOutlineUser
              style={{
                width: "80px",
                borderRadius: "50%",
                height: "80px",
                overflow: "hidden",
                marginTop: "40px",
                color: "white",
              }}
            />
            <img
              src={
                "https://media.istockphoto.com/vectors/user-icon-flat-isolated-on-white-background-user-symbol-vector-vector-id1300845620?k=20&m=1300845620&s=612x612&w=0&h=f4XTZDAv7NPuZbG0habSpU0sNgECM0X7nbKzTUta3n8="
              }
              alt=""
              style={{
                width: "80px",
                borderRadius: "50%",
                height: "80px",
                overflow: "hidden",
                marginTop: "40px",
              }}
            />

            <p className={`bg-white mt-4 ${styles.sidebarInfo}`}>{fullName}</p>
            <NavLink to="/customer-panel/profile">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center  ${styles.sidebarLink}`}
              >
                <BiUser />
                <p className="mt-2">پروفایل</p>
              </div>
            </NavLink>
            <NavLink to="/customer-panel/orders">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center ${styles.sidebarLink}`}
              >
                <ImFileText />
                <p className="mt-2">سفارشات</p>
              </div>
            </NavLink>

            <NavLink to="/customer-panel/messages">
              <div
                className={`d-flex mt-4 text-light d-flex justify-content-evenly align-items-center ${styles.sidebarLink}`}
              >
                <FiMessageSquare />
                <p className="mt-2">پیام ها</p>
              </div>
            </NavLink>
          </ul>
        </div>
      )}
    </>
  );
}
